export default __webpack_public_path__ + "static/media/IMG_2099.100da8f7.JPG";